// extracted by mini-css-extract-plugin
export default {"wtnBoxStyles":"wtnTeamBox_wtnBoxStyles__sCSeJ","wtnStyles":"wtnTeamBox_wtnStyles__omWG+"};